module.exports = __webpack_public_path__ + "static/media/pg04.56dbda38.jpg";